import React, {
  ForwardedRef,
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react'
import styles from '../styles.module.scss'
import { NumericFormat, NumericFormatProps } from 'react-number-format'

export type INumericInputElementProps = {
  placeholder?: string
  isReadOnly?: boolean
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  onFocus?: React.FocusEventHandler<HTMLInputElement>
  onClear?: () => void
} & NumericFormatProps

export const NumericInputElement = forwardRef(function TextInputRef(
  { isReadOnly, ...props }: INumericInputElementProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  const inputRef = useRef<HTMLInputElement | null>(null)

  useImperativeHandle<HTMLInputElement | null, HTMLInputElement | null>(
    ref,
    () => inputRef.current,
    []
  )

  return (
    <NumericFormat
      getInputRef={inputRef}
      className={styles.input}
      readOnly={isReadOnly}
      {...props}
    />
  )
})
